import React, { useState, useEffect } from "react";
import HelpMessage from "../Components/HelpMessage";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import dairyLinkLogo from "../Assets/Images/DairyLink-logo.svg";

const resetBrandTheme = () => {
  document.documentElement.style.setProperty("--brand-color", "#0f3d9a");
  document.documentElement.style.setProperty("--brand-secondary-color", "#4f6bd7");
  document.documentElement.style.setProperty("--secondary-color", "#4f6bd7");
  document.documentElement.style.setProperty("--brand-active-text-color", "#14223a");
  document.documentElement.style.setProperty("--active-text-color", "#14223a");
};

const Login = () => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    resetBrandTheme();
  }, []);

  // Check if current URL has ?user and token parameters
  const urlParams = new URLSearchParams(window.location.search);
  const paramUser = urlParams.get('user');
  const token = urlParams.get('deviceToken');

  if (paramUser && token) {
    axios.get(`${process.env.REACT_APP_API_BASEURL}/login/verify`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
    .then(response => {
      if (response.status === 200) {
        const { role } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("currentUser", response.data.id);
        localStorage.setItem("role", role);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('user');
        newUrl.searchParams.delete('deviceToken');
        newUrl.searchParams.delete('password');
        window.history.replaceState({}, document.title, newUrl.href);

        navigate("/Home");
      } else {
        console.error('Token verification failed');
      }
    })
    .catch(error => {
      console.error('Error verifying token:', error);
    });
  }

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASEURL}/login`, {
        user,
        password,
      });

      if (response.status === 200) {
        const { token, role } = response.data;
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        localStorage.setItem("instance_settings", JSON.stringify(response.data.instance_settings));
        
        // For admin users, preserve the last viewed supplier or it will be set in Home
        // For regular users, set currentUser to their supplier ID
        const isAdmin = role && role.toLowerCase().includes("admin");
        if (!isAdmin) {
          localStorage.setItem("currentUser", response.data.id);
        }
        // For admin, currentUser will be set when they visit Home or select a supplier

        const brandColor = response.data.instance_settings?.brandColor;
        if (brandColor) {
          document.documentElement.style.setProperty("--brand-color", brandColor);
        }

        const secondaryColor = response.data.instance_settings?.secondaryColor;
        if (secondaryColor) {
          document.documentElement.style.setProperty("--brand-secondary-color", secondaryColor);
          document.documentElement.style.setProperty("--secondary-color", secondaryColor);
        }

        const activeTextColor = response.data.instance_settings?.active_text_color;
        if (activeTextColor) {
          const resolved = activeTextColor === 'dark' ? '#1e1e1e' : '#fff';
          document.documentElement.style.setProperty("--brand-active-text-color", resolved);
          document.documentElement.style.setProperty("--active-text-color", resolved);
        }

        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        navigate("/Home");
      } else {
        setError("Invalid username or password");
      }
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        setError(error.response.data.message || "Error during login. Please try again.");
      } else {
        setError("Error during login. Please try again.");
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleLogin();
  };

  return (
    <div className="auth-screen customer-auth">
      <div className="auth-brand">
        <img src={dairyLinkLogo} alt="DairyLink" />
      </div>

      <div className="auth-card">
        <div className="auth-card__header">
          <h1>Sign in</h1>
          <p>Enter your credentials to continue.</p>
        </div>

        {error && <div className="alert error">{error}</div>}

        <form className="form-stack" onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="supplier-id">Supplier ID</label>
            <div className="form-field-control">
              <input
                id="supplier-id"
                type="text"
                placeholder="Enter your Supplier ID"
                value={user}
                onChange={(e) => setUser(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="supplier-password">Password</label>
            <div className="form-field-control">
              <input
                id="supplier-password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="auth-form-footer">
            <label className="auth-checkbox">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span>Remember me</span>
            </label>
            <button
              type="button"
              className="auth-link-button"
              onClick={() => navigate("/ForgotPassword")}
            >
              Forgot password?
            </button>
          </div>

          <button type="submit" className="button" style={{ width: '100%' }}>
            Sign in
          </button>
        </form>
      </div>

      <div className="auth-support">
        <HelpMessage />
      </div>
    </div>
  );
};

export default Login;
